import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronRight } from '@awaze/design-system.components.icon';
import { isPopularDestination as isValidPopularDestination } from '@awaze/design-system.utils.form';
export const buttonProtoProps = {
    type: 'button',
    size: 'small',
    variant: 'ghost',
    colourScheme: 'brand-tertiary',
    iconPosition: 'right',
    justify: 'space-between',
    icon: _jsx(ChevronRight, {}),
    fullWidth: true,
    isFullWidth: true,
};
export const getAutocompleteSource = (item) => {
    if (item.link) {
        return 'location-lookup';
    }
    if (item.type == 'GooglePlacesApiAutocomplete') {
        return 'google-autocomplete';
    }
    if (item.type == 'GooglePlacesApiTextSearch') {
        return 'google-textsearch';
    }
    if (item.type == 'l' || item.type == 't') {
        return 'places-api';
    }
};
export const fetchDestinations = async (path) => {
    const fetchResult = await fetch(path, {
        method: 'GET',
    })
        .then((response) => response.json())
        .then((response) => response)
        .catch((errorResponse) => {
        // eslint-disable-next-line no-console
        console.log('Fetch error: ', errorResponse);
        return { status: 404 };
    });
    return fetchResult;
};
/**
 * Formats required location path to JSON source file
 * @param locale ISO locales: en, en-gb, da-dk etc.
 * @param path Location of file source e.g.: /destination-data/novasol/en/
 * @param parent Identifier e.g.: countries | boats | 12345
 * @returns path + parent + _ + locale + .json = /destination-data/novasol/en/countries_en.json
 */
export const getDataPath = (locale, path, parent = 'countries') => `${path}${parent}_${locale}.json`;
export const getInitialParent = (initialParent, accommodationValue, accommodationOptions) => accommodationValue
    ? accommodationOptions?.filter((opt) => opt.value === accommodationValue)[0]
        ?.destinationListParentID
    : initialParent;
export const getRHSHeaders = (accommodationValue, accommodationOptions) => accommodationOptions?.filter((opt) => opt.value === accommodationValue)[0]
    ?.rhsHeaders;
export const selectLocation = (location, formHooks) => {
    const { id, name, url, legacyId, drupalId, type } = location;
    if (url) {
        /**
         * Only for hardcoded HOS and CDC JSON files with URL property
         * Located here (And in each MFE for this to work)
         * Design-System root: ~/static/destination-data/legacy/en
         */
        if (type === 'feature') {
            formHooks.setValue('featureId', id);
            formHooks.setValue('destinationId', '');
        }
        else {
            formHooks.setValue('destinationId', id);
            formHooks.setValue('featureId', '');
        }
        const [accommodationType] = formHooks.getValues(['accommodationType']);
        formHooks.setValue('destinationURL', accommodationType ? `/${accommodationType}${url}` : url);
    }
    else {
        /**
         * Places-API data
         * or
         * Data from Novasol Drupal JSON:
         * Located here (And in each MFE for this to work)
         * Design-System root: ~/static/destination-data/novasol
         */
        if (legacyId && isValidPopularDestination(legacyId)) {
            formHooks.setValue('featureId', legacyId);
            formHooks.setValue('destinationId', '');
        }
        else {
            formHooks.setValue('featureId', '');
            formHooks.setValue('destinationId', drupalId || legacyId);
        }
    }
    formHooks.setValue('id', id);
    formHooks.setValue('destination', name);
};
export const resolveDestinationListNavigation = (parentId, hasCustomRootElement) => !parentId || (hasCustomRootElement && parentId?.toString() === '0')
    ? null
    : parentId;
//# sourceMappingURL=destination-list.utils.js.map